import * as Sentry from "@sentry/browser";

var replay = Sentry.replayIntegration({
  // NOTE: This will disable built-in masking. Only use this if your site has no sensitive data, or if you've already set up other options for masking or blocking relevant data, such as 'ignore', 'block', 'mask' and 'maskFn'.
  maskAllText: false,
  maskAllInputs: false,
  blockAllMedia: false,
  networkDetailAllowUrls: ["/sales/edit_inquiry.json"],
  networkRequestHeaders: ["X-Custom-Header"],
  networkResponseHeaders: ["X-Custom-Header"],
});
Sentry.init({
  dsn: "https://8efdc33a761d121bf2dc2a5f6847887f@sentry.deiss.netropol.net/3",
  sendDefaultPii: true,
  tracesSampleRate: 1,
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
});
const client = Sentry.getClient();
client.addIntegration(replay);
var repl = Sentry.getReplay();
repl.flush();
repl.start();

if (document.getElementById("usermenu") != null) {
  Sentry.setUser({
    id: document.getElementById("usermenu").dataset.userId,
    username: document.getElementById("usermenu").dataset.userLogin,
  });
  Sentry.setContext("user", {
    id: document.getElementById("usermenu").dataset.userId,
    username: document.getElementById("usermenu").dataset.userLogin,
  });
}

import "@hotwired/turbo-rails"
Turbo.session.drive = true

import "../controllers/index"